import { render, staticRenderFns } from "./IframeComponent.vue?vue&type=template&id=4713ced4&"
import script from "./IframeComponent.vue?vue&type=script&lang=js&"
export * from "./IframeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports